<template>
  <div class="fm-chips-root">
    <div
      v-for="(chip, idx) in resolved"
      :key="idx"
      class="fm-chip"
      :class="[`fm-chip--${chip.zone}`]"
      :style="{
        backgroundColor: chip.color || 'var(--fm-chip-default)',
        color: chip.textColor || '#fff',
        [stackAxis(chip.zone) === 'x' ? 'left' : 'top']: chip.offset + 'px',
        [chip.zone.includes('right') ? 'right' : 'left']:
          stackAxis(chip.zone) === 'x' ? 'auto' : '4px',
      }"
    >
      <i v-if="chip.icon" :class="chip.icon" class="fm-chip-icon"></i>
      <span>{{ chip.label }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  chips: { type: Array, default: () => [] },
});

// Stack same-zone chips vertically; each chip ≈ 20px tall + 4px gap
const CHIP_H = 24;
const CHIP_GAP = 4;

function stackAxis(zone) {
  return 'y'; // always stack vertically; keeps layout predictable
}

const resolved = computed(() => {
  const counts = {};
  return props.chips.map((chip) => {
    const zone = chip.position || 'top-right';
    counts[zone] = (counts[zone] || 0);
    const offset = 4 + counts[zone] * (CHIP_H + CHIP_GAP);
    counts[zone]++;
    return { ...chip, zone, offset };
  });
});
</script>

<style scoped>
.fm-chips-root {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.fm-chip {
  position: absolute;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 0.6rem;
  font-weight: 700;
  white-space: nowrap;
  pointer-events: auto;
  box-shadow: 0 1px 3px rgba(0,0,0,.3);
  line-height: 1.4;
  --fm-chip-default: #6366f1;
}
.fm-chip--top-left    { top: 4px;  left: 4px;  }
.fm-chip--top-right   { top: 4px;  right: 4px; }
.fm-chip--bottom-left { bottom: 4px; left: 4px; }
.fm-chip--bottom-right{ bottom: 4px; right: 4px;}
/* Override top for stacked chips — set via inline :style offset */
.fm-chip--top-left[style],
.fm-chip--top-right[style],
.fm-chip--bottom-left[style],
.fm-chip--bottom-right[style] { top: unset; bottom: unset; }
.fm-chip-icon { font-size: 0.75em; }
</style>
